/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PROAUTH", "88")




export interface API20968Req {
  
  /** 排序资源 ,String */
  resourceIdList?: any[];
};



export interface API20968Res {
  /**   */
  code?: string;
  /**   */
  msg?: string;
  /**   */
  success?: boolean;
  /**   */
  exceptionMsg?: string;
  
};


// 20968 重排序常用功能

export interface IUsePostAPI20968Return {
  /** 重排序常用功能: 接口请求状态 */
  isAPI20968Loading: boolean;
  /** 重排序常用功能: 接口请求返回数据 */
  dataAPI20968: API20968Res;
  /**  重排序常用功能: 接口数据请求方法 */
  fetchAPI20968Data:  (inputs: API20968Req, config?: YWRequestConfig) => Promise<API20968Res>;
  /** 重排序常用功能: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI20968 = ():IUsePostAPI20968Return => {
  let isMount = true;
  const [isAPI20968Loading, setIsAPI20968Loading] = useState(false);
  const [dataAPI20968, setDataAPI20968] = useState<API20968Res>({} as API20968Res);
  const requestUrl = `${basePath}/ywwl-admin/desktop/home/common/function/sort`;

  const fetchAPI20968Data = async (inputs: API20968Req, config?: YWRequestConfig): Promise<API20968Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API20968Req>) || {}) as API20968Req;
    
  
    if ( isMount ) {
      setIsAPI20968Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API20968Res>(`${basePath}/ywwl-admin/desktop/home/common/function/sort`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI20968(res || {} as API20968Res);
        setIsAPI20968Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI20968Loading(false);
      }
      return false as unknown as API20968Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI20968Loading,
    dataAPI20968,
    fetchAPI20968Data,
    requestUrl,
  }
}

